import { type ToastifyId, isToastActive, showToast, updateToast } from '@lokalise/louis';

import type { BgProcessFinishedPayload, BgProcessUpdatedPayload } from '@app/sockets/socketTypes';

import ActivityDescription, { getProgress } from '../../components/ActivityDescription';

export interface Handler {
    onProgress(
        payload: Pick<BgProcessUpdatedPayload, 'bulk' | 'progress'>,
        toastId: ToastifyId,
        initial?: boolean,
    ): void;
    onFinished(payload: BgProcessFinishedPayload, isOnProjectPage: boolean): void;
    onEarlyFinish(payload: BgProcessFinishedPayload): void;
}

export const defaultUpdateAction = (
    toastId: ToastifyId,
    title: string,
    progressRaw: string,
    keyCount: number,
    initial = false,
) => {
    const progress = parseFloat(progressRaw) / 100;
    const done = getProgress(keyCount, progress);
    const activityDescription = `Completed ${done} of ${keyCount} keys`;

    if (isToastActive(toastId)) {
        updateToast(toastId, {
            title,
            description: <ActivityDescription progress={progress} description={activityDescription} />,
        });
    } else if (initial) {
        showToast({
            type: 'info',
            autoClose: false,
            toastId,
            title,
            description: <ActivityDescription progress={progress} description={activityDescription} />,
        });
    }
};

export { default as defaultFinishedAction } from './defaultFinishedAction';
